import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IDataEnviarGestion } from '../models/data_enviar_gestion';


@Injectable({
  providedIn: 'root'
})
export class ServiciosAdicionalesService {

    private apiUrl: string ='';
    private apiUrlComercial: string ='';
    constructor(private http: HttpClient) { 
        this.apiUrl = environment.SUrlgApi + 'ServiciosAdicionales';
        this.apiUrlComercial = environment.sUrlComercial + 'locations';
    }

    getListadoDeMovimientosFecha(fecha: string,fecha_fin: string,cod_usuario?:string): Observable<any[]> {
        let cod_usuario_cast = cod_usuario=='undefined' ? '': cod_usuario!; 
        const valores = {
            params: new HttpParams().
            set('fecha', fecha).
            set('fecha_fin', fecha_fin).
            set('cod_usuario', cod_usuario_cast)
        };
        return this.http
            .get<any[]>(this.apiUrl + '/GetListadoServiciosAdicionales', valores)
            .pipe(retry(1), catchError(this.handleError));
    }

    getKilometros(desc_origen:string,desc_destino:string): Observable<any> {
        const valores = {
            params: new HttpParams().
            set('origen', desc_origen).
            set('destination', desc_destino)
        };
        return this.http
        .get<any>(this.apiUrlComercial + '/km', valores)
        .pipe(retry(1), catchError(this.handleError));
    }

    getCalculoSueldo(num_km: number): Observable<any> {
        const valores = {
            params: new HttpParams().
            set('num_km', num_km)
        };
        return this.http
        .get<any>(this.apiUrl + '/CalculoSueldoViajeVacio', valores)
        .pipe(retry(1), catchError(this.handleError));
    }

    deleteViajeVacio(data:any):Observable<any>{
        const headers = { 'content-type': 'application/json'}  
        const valores = {
            params: new HttpParams().
            set('id', data.id).
            set('cod_usuario', data.cod_usuario)
        };
        return this.http.delete<any>(this.apiUrl+'/EliminarViajeVacio/',valores);
    }

    saveViajeVacio(data:any):Observable<any>{
        const headers = { 'content-type': 'application/json'}  
        const body = JSON.stringify(data); 
        return this.http.post<any>(this.apiUrl + '/SaveViajeVacio/',body,{'headers':headers});
    }

    handleError(error:any) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(() => {
            return errorMessage;
        });
    }
}
